import styled from 'styled-components'

export const RegisterWrapper = styled.div`
    min-height: 254px;

    padding: var(--gap-24);
    background: var(--white-100);
`

export const AddPsBtn = styled.div`
`